import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, NavigationCancel, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap, filter, take, debounceTime } from 'rxjs/operators';
import { ContactsService } from '../../results/contacts/services/contacts.service';
import { CompanyService } from '../../results/companies/services';
import { AuthenticationService, InitService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class AuthResultGuard  {
    constructor(
        private authenticationService: AuthenticationService,
        private contactService: ContactsService,
        private companieService: CompanyService,
        private router: Router,
        private readonly initService: InitService,
    ) {
        this.router.events
            .pipe(filter((event: NavigationCancel) => {
                return (event instanceof NavigationCancel);
            })).subscribe((event: NavigationCancel) => {
                if (event.url.indexOf('/results/contacts/') > -1) {
                    localStorage.setItem('savedSearchURL', event.url);
                } else if (event.url.indexOf('/company/') > -1) {
                    localStorage.setItem('companyDetailURL', event.url);
                }
            });
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.authenticationService.checkUserAlreadyValidLogin().pipe(
            take(1),
            filter((valid: boolean) => {
                if (!valid) {
                    this.authenticationService.navigateToLogin(state.url);
                }
                return valid;
            }),
            /**
             * Once user is logged in and before he redirected to 'cabinet'
             * all necessary requests are made here
             *
             * P.S. debounceTime(100) is MANDATORY here for app.component.html layout, there are
             * 2 router-outlet, only one shown based on InitService.isInitiated$, once it is true
             * internal resources initiated, but router-outlets switching causes 2nd initiate of the components
             */
            switchMap(() => this.initService.initiate().pipe(debounceTime(100))),
            take(1),
            map(() => {
                if (this.authenticationService.isFromLogin) {
                    this.authenticationService.isFromLogin = false;
                    this.checkLoggedUserHaveAllPermissions(this.authenticationService.user);
                }
                return true;
            })
        );
    }

    checkLoggedUserHaveAllPermissions(user) {
        if (user){
            if (this.authenticationService.checkLoggedUserHaveAllPermissions(user)) {
                this.contactService.requestResearch();
                this.companieService.requestResearch();
            } else {
                this.authenticationService.navigateToUpgrade();
            }
        } else {
            this.authenticationService.navigateToUpgrade();
        }
    }
}
